import Hls from 'hls.js';

require('../../stylesheets/common/video-player.scss');

document.addEventListener('DOMContentLoaded', (event) => {
    const videoElements = document.querySelectorAll('video[src$=".m3u8"]:not([data-hls])');

    if (!videoElements.length || videoElements[0].canPlayType('application/vnd.apple.mpegurl') || !Hls.isSupported()) {
        return;
    }

    for (const videoElement of videoElements) {
        const hls = new Hls();

        hls.loadSource(videoElement.getAttribute('src'));
        hls.attachMedia(videoElement);

        videoElement.dataset.hls = "true";
    }
});
